export const BookingStatus = {
  READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  READY_TO_INVOICE: 'READY_TO_INVOICE',
  PARTIAL_INVOICED: 'PARTIAL_INVOICED',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  NO_SHOW: 'NO_SHOW',
  UNCLAIMABLE: 'UNCLAIMABLE',
};

export const BookingSeconStatus = {
  PENDING_START: 'PENDING_START',
  CASE_ASSIGNED: 'CASE_ASSIGNED',
  CASE_PICKED: 'CASE_PICKED',
  CASE_DONE: 'CASE_DONE',
  APPROVED_BREAK_LEASE: 'APPROVED_BREAK_LEASE',
  NO_BOOKING_PROOF: 'NO_BOOKING_PROOF',
  AGENT_CLASH: 'AGENT_CLASH',
  CAP_REACHED: 'CAP_REACHED',
  ZERO_COMMISSION: 'ZERO_COMMISSION',
  REBOOKER: 'REBOOKER',
  SHORT_STAY: 'SHORT_STAY',
  MISCELLANEOUS: 'MISCELLANEOUS',
  TENANCY_TAKEOVER: 'TENANCY_TAKEOVER',
  BOOKING_PROCESS: 'BOOKING_PROCESS',
  UNCLAIMABLE_BREAK_LEASE: 'UNCLAIMABLE_BREAK_LEASE',
  FULLY_APPROVED: 'FULLY_APPROVED',
  CASE_CLOSED: 'CASE_CLOSED',
  CREDIT_NOTE: 'CREDIT_NOTE',
};

export const pendingNoteList = {
  STUDENT_CANCELLATION: 'STUDENT_CANCELLATION',
  STUDENT_NO_SHOW: 'STUDENT_NO_SHOW',
  INCOMPLETE: 'INCOMPLETE',
  SHORT_STAY: 'SHORT_STAY',
  NO_BOOKING_PROOF: 'NO_BOOKING_PROOF',
  AGENT_CLASH: 'AGENT_CLASH',
  CAP_REACHED: 'CAP_REACHED',
  ZERO_COMMISSION: 'ZERO_COMMISSION',
  REBOOKER: 'REBOOKER',
  TENANCY_TAKEOVER: 'TENANCY_TAKEOVER',
  BREAK_LEASE: 'BREAK_LEASE',
  BOOKING_PROCESS: 'BOOKING_PROCESS',
  MISCELLANEOUS: 'MISCELLANEOUS',
};
